// @mui icons
import Icon from '@mui/material/Icon'

import ClientAdmin from 'clients/admin/ClientAdmin/ClientAdmin'
import UserAdmin from 'clients/admin/UserAdmin/UserAdmin'
import GrantAdmin from 'pages/common/admin/GrantAdmin'
import ResourceAdmin from 'pages/common/admin/ResourceAdmin'

/************************************************
 * Client-specific pages
 ************************************************/
import PlaceHolder from 'clients/PlaceHolder'

const reportViews = {
  reportPH: {
    name: 'Place Holder',
    key: 'repPH',
    route: '/reports/repPH',
    component: <PlaceHolder />
  }
}

const adminViews = {
  clientAdmin: {
    name: 'Client Admin',
    key: 'client-admin',
    route: '/clientAdmin',
    component: <ClientAdmin />
  },
  userAdmin: {
    name: 'User Admin',
    key: 'user-admin',
    route: '/userAdmin',
    component: <UserAdmin />
  },
  grantAdmin: {
    name: 'Grant Admin',
    key: 'grant-admin',
    route: '/grantAdmin',
    component: <GrantAdmin />
  },
  resourceAdmin: {
    name: 'Resource Admin',
    key: 'resource-admin',
    route: '/admin/resource-admin',
    component: <ResourceAdmin />
  }
}

export default function rdxRoutes(role, permissions) {
  console.log('[rdxRoutes] Called with:', {
    role,
    permissionsType: typeof permissions,
    permissionsIsArray: Array.isArray(permissions),
    permissionsLength: permissions?.length,
    permissions: permissions
  });

  let reportViewArr = []
  let adminViewArr = []

  // Setup Admin Views
  console.log('[rdxRoutes] Checking role for admin views:', role);
  switch(role){
    case 'Admin':
      console.log('[rdxRoutes] Role matched "Admin", setting up admin views');
      adminViewArr[0] = adminViews.clientAdmin
      adminViewArr[1] = adminViews.userAdmin
      adminViewArr[2] = adminViews.grantAdmin
      adminViewArr[3] = adminViews.resourceAdmin
      console.log('[rdxRoutes] Admin views array length:', adminViewArr.length);
      break;
    default:
      console.log('[rdxRoutes] Role did not match "Admin", using default (no admin views)');
      // No action, leave as empty array
  }

  // Setup Report Views
  console.log('[rdxRoutes] Processing report views from permissions array');
  let arrIdx = 0
  for(let i = 0; i < permissions.length; i++){
    let report = permissions[i].report
    report = report.toLowerCase()
    if(report in reportViews){
      let viewPermissions = permissions[i].viewPermissions
      if(viewPermissions !== 'no-permission'){
        reportViewArr[arrIdx] = reportViews[report]
        arrIdx += 1
      }
    }
  }
  console.log('[rdxRoutes] Report views array length:', reportViewArr.length);

  // Create Routes
  let routes = []

  if(reportViewArr.length > 0){
    console.log('[rdxRoutes] Adding report routes section');
    let reportRoutes = {
      type: 'collapse',
      name: 'Reports',
      key: 'reports',
      icon: <Icon fontSize='medium'>format_list_numbered_icon</Icon>,
      collapse: reportViewArr
    }
    routes.push(reportRoutes)
  }

  if(adminViewArr.length > 0){
    console.log('[rdxRoutes] Adding admin routes section');
    let adminRoutes = {
      type: 'collapse',
      name: "Admin Tools",
      key: 'admin-tools',
      icon: <Icon fontSize='medium'>content_paste</Icon>,
      collapse: adminViewArr,
    }
    routes.push(adminRoutes)
  } else {
    console.log('[rdxRoutes] Skipping admin routes - adminViewArr is empty');
  }

  let finalDivider = {
    type: 'divider',
    key: 'final-divider'
  }
  routes.push(finalDivider)

  console.log('[rdxRoutes] Returning routes, total count:', routes.length);
  console.log('[rdxRoutes] Routes structure:', routes);

  return routes
}